// Hand-maintained (no cs2ts generator source for this file): every value must match a
// string that UserManagementService.ResolveEffectiveRoleName can return for UserClaims.UserRole
// on the backend. Keep the two in sync; order mirrors that method's most-privileged-first precedence.
export const userRoles = {
    dcarb_admin: 'dcarb_admin',
    quickscan_global_admin: 'quickscan_global_admin',
    quickscan_dedicated_admin: 'quickscan_dedicated_admin',
    main_user: 'main_user',
    secondary_user: 'secondary_user',
    viewer: 'viewer',
};
